export default {
    getPreCart: { method: 'post', url: 'sale/open/get_pre_cart/' },
    getCartComplete: { method: 'get', url: 'sale/open/?user={id}' },
  }